export const LOADING_CLOSE_BUTTON_TIME = 4_000 //4 seconds
